import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["form", "saveChanges"];

  connect() {
    this.originalState = this.captureFormState();
  }

  handleChange(e) {
    const saveChanges = e.currentTarget
      .closest("form")
      .querySelector(".save-changes");

    if (this.hasChanges()) {
      saveChanges.style.display = "flex";
    } else {
      saveChanges.style.display = "none";
    }
  }

  captureFormState() {
    const form = this.element.closest("form");
    const formData = new FormData(form);
    const state = {};

    for (const [name, value] of formData.entries()) {
      if (state[name]) {
        if (!Array.isArray(state[name])) {
          state[name] = [state[name]];
        }
        state[name].push(value);
      } else {
        state[name] = value;
      }
    }

    return state;
  }

  hasChanges() {
    const currentState = this.captureFormState();
    const originalState = this.originalState;

    return JSON.stringify(currentState) !== JSON.stringify(originalState);
  }
}
